import { Component, Input } from '@angular/core';
import * as i0 from "@angular/core";
export class AriaNotifierComponent {
    ngOnChanges(changes) {
        if (changes.hasOwnProperty('notifierService')) {
            if (!this.notifierSubscription) {
                this.subscribeToNotifier();
            }
            else {
                this.notifierSubscription.unsubscribe();
                this.subscribeToNotifier();
            }
        }
    }
    ngOnDestroy() {
        if (this.notifierSubscription) {
            this.notifierSubscription.unsubscribe();
        }
    }
    subscribeToNotifier() {
        this.notifierSubscription = this.notifierService.messageObservable.subscribe((message) => {
            this.status = message;
            setTimeout(() => (this.status = ''), 1000);
        });
    }
}
AriaNotifierComponent.ɵfac = function AriaNotifierComponent_Factory(t) { return new (t || AriaNotifierComponent)(); };
AriaNotifierComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AriaNotifierComponent, selectors: [["DataTable-table-aria-notifier"]], inputs: { tableId: "tableId", notifierService: "notifierService" }, features: [i0.ɵɵNgOnChangesFeature], decls: 2, vars: 2, consts: [["aria-atomic", "true", "aria-live", "polite", 1, "notification-area", "screen-reader", "sr-only", 3, "id"]], template: function AriaNotifierComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtext(1);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵpropertyInterpolate1("id", "DataTable-table-aria-notifier-", ctx.tableId, "");
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", ctx.status, " ");
    } }, styles: ["\n"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AriaNotifierComponent, [{
        type: Component,
        args: [{ selector: 'DataTable-table-aria-notifier', template: ` <div
    id="DataTable-table-aria-notifier-{{ tableId }}"
    class="notification-area screen-reader sr-only"
    aria-atomic="true"
    aria-live="polite"
  >
    {{ status }}
  </div>`, styles: ["/*# sourceMappingURL=table.component.css.map */\n"] }]
    }], null, { tableId: [{
            type: Input
        }], notifierService: [{
            type: Input
        }] }); })();
